(ns client-portal.client.conversations.individual.views
  (:require [client-portal.client.conversations.individual.data :as conversation.d]
            [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.components.theme :as theme]
            [client-portal.client.audio.views :as audio]
            [shared.core.util :as util]))

(defn detail-label [{:keys [label no-label style]}]
  [:span {:style (cond-> {:color (style/color :on-background :base)
                          :font-size 14
                          :flex 1
                          :display :flex
                          :justify-content :center
                          :margin-left 3}
                         (empty? label) (assoc :opacity 0.5)
                         style (merge style))}
   (if (not-empty label)
     label
     no-label)])

(defn conversation-details [_]
  (let [franchise-groups-data-keyed- (re/subscribe [:cohorts/franchise-groups-data-keyed-])]
    (fn [{:keys [conversation]}]
      (let [{:keys [conversation-id location-brand-id location-name+brand-id location-city-state franchise-group-label
                    phone-call-timestamp-formatted]}
            (conversation.d/with-display-details conversation @franchise-groups-data-keyed-)
            light-gray-border (str "1px solid " (style/color :gray :shade-7))]
        [:div {:style {:flex "0 0 auto"
                       :display :flex
                       :flex-direction :column
                       :align-items :center
                       :width "100%"}}
         [:div {:style {:position :absolute
                        :top 8
                        :left 8}}
          [:div {:style {:display :flex
                         :align-items :center}}
           [c/material-icon {:icon-type :pin
                             :style {:color (style/color :on-background :base)
                                     :font-size 14}}]
           [c/a {:style {:color (style/color :on-background :base)
                         :font-size 14
                         :margin-left 3}
                 :on-click #(re/dispatch [:core/copy-to-clipboard conversation-id {:notify? true}])}
            "Copy Conversation ID"]]]
         (when (not-empty location-name+brand-id)
           [:div {:style {:display :flex
                          :align-items :center}}
            [:span {:style {:color (style/color :primary :base)
                            :font-size 17
                            :font-weight style/font-extra-bold-weight
                            :margin-right 5}}
             location-name+brand-id]
            (when location-brand-id
              [c/copy-icon-tooltip {:tooltip-content "Copy Store ID"
                                    :copy-text location-brand-id
                                    :icon-style {:color (style/color :primary :base)
                                                 :font-size 17}}])])
         [:div {:style {:display :flex
                        :align-items :center
                        :justify-content :center
                        :margin-top 20
                        :width "100%"}}
          [detail-label {:label location-city-state
                         :no-label "No Location Details"}]
          [detail-label {:label phone-call-timestamp-formatted
                         :no-label "No Call Time"
                         :style {:border-right light-gray-border
                                 :border-left light-gray-border}}]
          [detail-label {:label franchise-group-label
                         :no-label "No Franchise Group"}]]]))))

(defn speech-bubble-container [{:keys [container-style bubble-style text align-to-end? jump-to bubble-hover-style]}]
  [:div {:style (merge {:display :flex
                        :align-items :center
                        :margin "8px 0"
                        :width "100%"}
                       container-style)}
   (when align-to-end?
     [c/spacer])
   [c/interactive
    :div {:style (merge {:background-color (style/color :primary :base)
                         :border-radius 8
                         :color (style/color :on-primary :base)
                         :font-size 16
                         :line-height 1.3
                         :flex "0 0 auto"
                         :padding 12
                         :max-width "75%"
                         :transition "0.2s"}
                        bubble-style)
          :hover-style (when jump-to
                         (merge {:cursor :pointer
                                 :box-shadow style/sh-primary-box-shadow}
                                bubble-hover-style))
          :on-click (when jump-to
                      #(re/dispatch-sync [:conversations/active-jump-to-time jump-to]))}
    text]
   (when-not align-to-end?
     [c/spacer])])

(defn conversation-dialogue [{:keys [audio-url utterances style]}]
  (into
    [:div {:style (merge {:background-color (util/hex->rgba (style/color :on-background :base) 0.03)
                          :border (str "1px solid " (style/color :gray :shade-7))
                          :border-radius 8
                          :flex 1
                          :margin "30px 0 20px"
                          :padding 25
                          :overflow :auto
                          :position :relative
                          :width "100%"}
                         style)}
     (when audio-url
       [:div {:style {:position :absolute
                      :top 5
                      :right 5}}
        [c/info-tooltip {:tooltip-content "Click on a text bubble to jump to that part of the conversation"}]])]
    (if (not-empty utterances)
      (map (fn [{:keys [user-said user-said-time bot-response bot-response-time]}]
             [:div
              (when user-said
                [speech-bubble-container {:text user-said
                                          :align-to-end? true
                                          :jump-to (when audio-url user-said-time)}])
              (when bot-response
                [speech-bubble-container {:text bot-response
                                          :bubble-style {:background-color (style/color :white :base)
                                                         :color (style/color :on-background :base)
                                                         :border (str "1px solid " (style/color :gray :shade-7))}
                                          :bubble-hover-style {:box-shadow style/sh-on-gray-box-shadow}
                                          :jump-to (when audio-url bot-response-time)}])])
           utterances)
      [[theme/theme
        :div {:style (merge {:color (style/color :on-background :base)
                             :font-size 16
                             :font-weight style/font-medium-weight
                             :text-align :center
                             :opacity 0.7
                             :padding "40px 0"}
                            style)
              :theme (style/dark-style {:color (style/dark-color :on-background :base)})}
        "No Conversation Dialogue Found"]])))

(defmethod c/modal-view
  :conversations/conversation-modal [_ {:keys [background-click conversation]}]
  (let [full-convo @(re/subscribe [:conversations/individual-data- (:conversation-id conversation)])
        loading? (util/loading? full-convo)
        calc-height "calc(100vh - 90px)"
        conversation (or (util/when-not-loading full-convo) conversation)]
    (into [c/primary-modal {:background-click background-click
                            :close-on-esc? true
                            :container-style {:margin "60px 0 30px"
                                              :min-height calc-height}
                            :style (cond-> {:padding "50px 40px 100px"
                                            :position :relative
                                            :width "95%"
                                            :max-width 900}
                                           loading? (assoc :min-height calc-height)
                                           (not loading?) (assoc :max-height calc-height))}]
          [(when (not-empty conversation)
             [conversation-details {:conversation conversation}])
           (if loading?
             [:div {:style {:display :flex
                            :align-items :center
                            :justify-content :center
                            :flex 1}}
              [c/primary-spinner {:size 30}]]
             [conversation-dialogue conversation])
           [:div {:style {:background-color (util/hex->rgba (style/color :primary :base) 0.4)
                          :border-radius "0 0 8px 8px"
                          :display :flex
                          :align-items :center
                          :justify-content :center
                          :position :absolute
                          :bottom 0
                          :left 0
                          :height 90
                          :width "100%"}}
            (if-let [audio-url (:audio-url conversation)]
              [audio/audio-player {:audio-id :conversation-audio-player
                                   :url audio-url}]
              (when-not loading?
                [:span {:style {:color (style/color :primary :base)
                                :font-size 16
                                :text-align :center}}
                 "No Audio Available"]))]])))
